import get from 'lodash/get';
import { useEditField } from '@atlassian/jira-issue-field-base/src/services/edit-field-service/main.tsx';
import { useFieldConfig } from '@atlassian/jira-issue-field-base/src/services/field-config-service/main.tsx';
import type { CmdbObject } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/cmdb-object.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

type Props = {
	issueKey: IssueKey;
	fieldKey: string;
	onSaveField: (issueKey: IssueKey, fieldKey: string, newValue: CmdbObject[]) => Promise<undefined>;
	onSuccess?: (arg1: CmdbObject[]) => void;
	onFailure?: (arg1: Error) => void;
};

export const useCmdbObjectField = ({
	issueKey,
	fieldKey,
	onSuccess,
	onFailure,
	onSaveField,
}: Props) => {
	// useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
	// if possible when touching this, try and refactor to pass the new object instead of just the value
	const [{ value: fieldConfig }] = useFieldConfig(issueKey, fieldKey);
	const fieldType = get(fieldConfig, 'schema.type', 'array');

	const [{ value, error }, { saveValue, resetError }] = useEditField<CmdbObject[], null>({
		fieldKey,
		issueKey,
		fieldType,
		initialValue: [],
		onSuccess,
		onFailure,
		saveField: onSaveField,
	});

	return [
		{ value, error, fieldConfig },
		{ saveValue, resetError },
	] as const;
};
